import { FC } from 'react';

export const CreditCard: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<title>Credit card</title>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7ZM4 11V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V11H4ZM20 9H4V7C4 6.44772 4.44772 6 5 6H19C19.5523 6 20 6.44772 20 7V9ZM6 15C6 14.4477 6.44772 14 7 14H7.00889C7.56117 14 8.00889 14.4477 8.00889 15C8.00889 15.5523 7.56117 16 7.00889 16H7C6.44772 16 6 15.5523 6 15ZM9.00889 15C9.00889 14.4477 9.4566 14 10.0089 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H10.0089C9.4566 16 9.00889 15.5523 9.00889 15Z"
			fill="currentColor"
		/>
	</svg>
);
